import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin"
        ? [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },
          {
            id: 2,
            label: "Masters",
            icon: WSIcons.Masters,
            children: [
              {
                id: 3,
                label: "Banner",
                path: "/banner/list"
              },
              {
                id: 4,
                label: "Designations",
                path: "/designations"
              },
              {
                id: 5,
                label: "Departments",
                path: "/departments"
              },
              {
                id: 6,
                label: "Leave Type",
                path: "/leavetypes"
              },
              {
                id: 7,
                label: "Schedule Meeting",
                path: "/schedule/list"
              },
              {
                id: 8,
                label: "Announcement",
                path: "/announcement/list"
              }
            ]
          },

          {
            id: 9,
            label: "Products",
            icon: WSIcons.PersonOffIcon,
            children: [
              {
                id: 9,
                label: "Product List",
                path: "/product/list"
              },
              {
                id: 10,
                label: "Wish List",
                path: "/wish/list"
              }
            ]
          },

          {
            id: 13,
            label: "Settings",
            icon: WSIcons.SettingsIcon,
            children: [
              {
                id: 14,
                label: "Organization",
                path: "/organization/view"
              },
              {
                id: 15,
                label: "Change Password",
                path: "/changepassword"
              }
            ]
          }
        ]
        : [
          {
            id: 1,
            label: "Home",
            icon: WSIcons.Home,
            path: "/home"
          },

          {
            id: 8,
            label: "Modules",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            children: [
              {
                id: 9,
                label: "Leads",
                path: "/leads/list"
              },
              {
                id: 4,
                label: "Contacts",
                path: "/contacts/list"
              },
              // {
              //   id: 141,
              //   label: "Deals",
              //   path: "/deals/list"
              // },
              {
                id: 147,
                label: "Users",
                path: "/user/list"
              },
              {
                id: 142,
                label: "Roles",
                path: "/role/list"
              }, 
              //    {
              //     "id": 143,
              //     "label": "Quatation",
              //     "icon": WSIcons.TrendingUp,
              //     "path": "/quatation/list"
              // },
            ]
          },

          {
            id: 16,
            label: "Deals",
            icon: WSIcons.DealIcon,
            path: "/deals/list"
          },
          {
            id: 18,
            label: "Meetings",
            icon: WSIcons.ScheduleIcon,
            path: "/meeting/list"
          },
          {
            id: 17,
            label: "Tasks",
            icon: WSIcons.TaskIconNew,
            path: "/task/list"
          },

          {
            id: 19,
            label: "Call",
            icon: WSIcons.CallIcon,
            path: "/call/list"
          },
          {
            id: 20,
            label: "Notes",
            icon: WSIcons.NoteIcon,
            path: "/note/list"
          },
           {
            id: 17,
            label: "Survey",
            icon: WSIcons.AllInclusiveOutlinedIcon,
            path: "/survey/list"
          },
        ]
  };
};
